import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIMaskReveal',
    props: {
        as: { default: "div" },
        delay: { default: 0 }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "6d77b97c": (props.delay)
        }));
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { appear: "" }, {
                default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.as), { class: "UIMaskReveal" }, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                        _: 3
                    }))
                ]),
                _: 3
            }));
        };
    }
});
